import { Injectable } from "@angular/core"

export interface AppSettings {
  apiUrl: string
}

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  public GetSettings = (): AppSettings => ({
    apiUrl: document.getElementsByTagName("base")[0].href
  })
}
